export enum EventRegistationActionTypeEnum {
  None,
  RegistrationProfileChanged,
  RegistrationContactInfoChanged,
  AttendeeProfileChanged,
  AttendeeContactInfoChanged,
  AttendeeAdded,
  AttendeeRemoved,
  EventItemQuantityChanged,
  ForceMemberPricingChanged,
  MarkAsPaidSet,
  DoNotInvoiceSet,
  CreateProfileSet,
  CustomFieldCostChanged,
  PromoCodeChanged,
  BenefitChanged,
}
